//=> https://developers.google.com/analytics/devguides/collection/ga4/reference/events#add_to_cart

class BeginCheckoutEventListener {
    // Language: javascript
    // Path: BeginCheckoutEventListener.js
    // Compare this snippet from EventListener.js:

    get CheckoutProducts() {
        return ".gtm-checkout-products";
    }

    get DefaultEventName() {
        return "click";
    }

    constructor(element, eventName = this.DefaultEventName) {
        this.element = element;
        this.eventName = eventName;
    }

    callback() {
        const dataLayer = new DataLayer();
        dataLayer.clear();
        var items = [];

        var checkoutProducts = document.querySelectorAll(
            BeginCheckoutEventListener.prototype.CheckoutProducts
        );

        for (var i = 0; i < checkoutProducts.length; i++) {
            var cartItem = checkoutProducts[i];
            var analyticsData = cartItem.dataset.analytics
                ? JSON.parse(cartItem.dataset.analytics)
                : null;

            if (analyticsData && cartItem.dataset) {
                var analticsDataProducts = analyticsData.products
                    ? analyticsData.products[0]
                    : null;

                var price = Number(
                    analticsDataProducts.price.replace(",", ".")
                ).toFixed(2);
                var pricewithdiscount = Number(
                    analticsDataProducts.pricewithdiscount.replace(",", ".")
                ).toFixed(2);

                var item = {
                    item_id: analticsDataProducts.code,
                    item_name: analticsDataProducts.name,
                    item_brand: analticsDataProducts.brand,
                    item_category: analticsDataProducts.category,
                    currency: analticsDataProducts.currency,
                    price: pricewithdiscount,
                    quantity: cartItem.dataset.quantity,
                };

                if (analticsDataProducts.categories) {
                    var splitCategories =
                        analticsDataProducts.categories.split(";");
                    for (var j = 0; j < splitCategories.length; j++) {
                        if (j == 0) {
                            item["item_category"] = splitCategories[j];
                        } else {
                            item["item_category" + j] = splitCategories[j];
                        }
                    }
                }

                if (cartItem.dataset.variant) {
                    var variant = JSON.parse(cartItem.dataset.variant);
                    if (variant) {
                        item["item_variant"] = Object.values(variant).join(",");
                    }
                }

                if (price != pricewithdiscount) {
                    item["price"] = price;
                    item["discount"] = (price - pricewithdiscount).toFixed(2);
                }

                items.push(item);
            }
        }

        if (items.length > 0) {
            SendData(dataLayer);
        }

        function SendData(dataLayer) {
            dataLayer
                .push({
                    event: "begin_checkout",
                    ecommerce: {
                        items: items,
                    },
                })
                .then(() => {
                    var instanceActivate = new ActivateGtm();
                    instanceActivate.activatePurchaseCheckout();
                    console.log("GTM pushed begin_checkout event");
                })
                .catch((error) => {
                    console.warn("GTM error begin_checkout event", error);
                });

            if (typeof gtag !== "undefined" && !!gtag) {
                gtag("event", "begin_checkout", {
                    event_category: "Enhanced Ecommerce",
                    event_label: "begin checkout",
                    items: items,
                });
            }
        }
    }

    listen() {
        this.element.addEventListener(
            this.eventName,
            BeginCheckoutEventListener.prototype.callback
        );
    }
    remove() {
        this.element.removeEventListener(
            this.eventName,
            BeginCheckoutEventListener.prototype.callback
        );
    }
}
